export const version = "strings/5.6.1";
//# sourceMappingURL=_version.js.map